import Country from './Country';

export default Country;
